import React, { useEffect, useState } from "react";
import { Grid, TextField, Button, Paper, Snackbar, Alert, InputAdornment, IconButton, Typography } from '@mui/material';
import { setToast } from "../redux/slices/toastSlice";
import { useDispatch } from 'react-redux';
import logo from '../images/cg-logo-new.png';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import createAxiosInstance from "../utils/axiosInstance";
import { DEFAULT_ERROR_MESSAGE } from "../constants";
import { useNavigate } from 'react-router-dom';
import { validatePassword } from "../utils/validators";


const RegisterNewUser = (props) => {
    const {
        toggleMode
    } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [openToastMeesage, setOpenToast] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [userInfo, setUserInfo] = useState({ email: '', password: '', confirm_password: '', username: '' });
    const [userInfoErrors, setUserInfoErrors] = useState({
                                                    email: '',
                                                    password: '',
                                                    confirm_password: '',
                                                    user_name: '',
                                                    first_name: '',
                                                    last_name: ''
                                                });
    const handleChange = (e) => {
        const { value, name } = e?.target;
        setUserInfo((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }));
        if (userInfoErrors[name]) {
            setUserInfoErrors((prevErrors) => ({
                ...prevErrors,
                [name]: ''
            }));
        }
    };

    const handleCloseToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenToast(false);
    };

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleRegisterNewUser = async () => {
        try {
            const requiredFields = ['email', 'username', 'password', 'confirm_password', 'first_name'];
            let haveErrors = false;
            for (const field of requiredFields) {
                if (!userInfo?.[field]?.trim()?.length) {
                    setUserInfoErrors((prevErrors) => ({
                        ...prevErrors,
                        [field]: 'Please fill this field'
                    }));
                    haveErrors = true;
                };
            };

            if (haveErrors) {
                return;
            }
            const isPasswordValid = validatePassword(userInfo?.password);
            if (!isPasswordValid) {
                return setUserInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    password: 'minimum 8 chars including 1 upper, 1 lower, 1 digit'
                }));;
            };
            if (userInfo?.password !== userInfo?.confirm_password) {
                return setUserInfoErrors((prevErrors) => ({
                    ...prevErrors,
                    confirm_password: 'Passwords not matching'
                }));;
            };
            setIsLoading(true);
            const resp = await createAxiosInstance({}, 'public').post('api/auth/local/register', userInfo);
            if (resp?.data?.user) {
                dispatch(setToast({ type: 'success', open: true, message: 'Click on the confirmation email sent to you for account activation' }));
                setTimeout(() => {
                    window.location.href = '/login';
                }, 2000);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            dispatch(setToast({
                type: 'error',
                open: true,
                message: error?.response?.data?.error?.message || DEFAULT_ERROR_MESSAGE
            }));
        }

    };

    return (
        <Grid
            container
            justifyContent='center'
            alignItems='center'
            className='cg-login-container'
        >
            <Snackbar
                open={openToastMeesage}
                autoHideDuration={5000}
                onClose={handleCloseToast}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleCloseToast} severity="success" sx={{ width: '100%' }}>
                    Please verify your email to confirm registration
                </Alert>
            </Snackbar>
            <Paper elevation={3} className='cg-login-card'>
                <Grid align="center">
                    <div className="cg-logo-container">
                        <img src={logo} alt="CampaignGuru" className="cg-logo" />
                    </div>
                    <Typography variant="h5" align="center" className='cg-title'>
                        Create Account
                    </Typography>
                    <Typography variant="body1" align="center" className='cg-subtitle'>
                        Register for a new CampaignGuru account
                    </Typography>
                </Grid>
                <div className="cg-form-field">
                    <label className="cg-input-label">Email</label>
                    <TextField
                        variant="outlined"
                        fullWidth
                        placeholder='you@example.com'
                        name="email"
                        value={userInfo.email}
                        onChange={handleChange}
                        required
                        helperText={userInfoErrors?.email}
                        FormHelperTextProps={{ error: Boolean(userInfoErrors?.email), sx: { marginLeft: '0px' } }}
                    />
                </div>

                <div className="cg-form-field">
                    <label className="cg-input-label">First Name</label>
                    <TextField
                        variant="outlined"
                        fullWidth
                        name="first_name"
                        value={userInfo.first_name}
                        onChange={handleChange}
                        required
                        helperText={userInfoErrors?.first_name}
                        FormHelperTextProps={{ error: Boolean(userInfoErrors?.first_name), sx: { marginLeft: '0px' } }}
                    />
                </div>

                <div className="cg-form-field">
                    <label className="cg-input-label">Last Name</label>
                    <TextField
                        variant="outlined"
                        fullWidth
                        name="last_name"
                        value={userInfo.last_name}
                        onChange={handleChange}
                    />
                </div>

                <div className="cg-form-field">
                    <label className="cg-input-label">User Name</label>
                    <TextField
                        variant="outlined"
                        fullWidth
                        name="username"
                        value={userInfo.username}
                        onChange={handleChange}
                        required
                        helperText={userInfoErrors?.username}
                        FormHelperTextProps={{ error: Boolean(userInfoErrors?.username), sx: { marginLeft: '0px' } }}
                    />
                </div>

                <div className="cg-form-field">
                    <label className="cg-input-label">Password</label>
                    <TextField
                        fullWidth
                        variant="outlined"
                        name="password"
                        value={userInfo.password}
                        onChange={handleChange}
                        placeholder='••••••••'
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleTogglePassword}
                                        edge="end"
                                    >
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        required
                        helperText={userInfoErrors?.password}
                        FormHelperTextProps={{ error: Boolean(userInfoErrors?.password), sx: { marginLeft: '0px' } }}
                    />
                </div>

                <div className="cg-form-field">
                    <label className="cg-input-label">Confirm Password</label>
                    <TextField
                        variant="outlined"
                        fullWidth
                        name="confirm_password"
                        value={userInfo.confirm_password}
                        onChange={handleChange}
                        placeholder='••••••••'
                        type='password'
                        required
                        helperText={userInfoErrors?.confirm_password}
                        FormHelperTextProps={{ error: Boolean(userInfoErrors?.confirm_password), sx: { marginLeft: '0px' } }}
                    />
                </div>

                <Button
                    fullWidth
                    className="cg-primary-btn"
                    style={{ marginTop: '8px' }}
                    onClick={handleRegisterNewUser}
                    disabled={isLoading}
                >
                    {isLoading ? 'Creating Account...' : 'Create Account'}
                </Button>
                <Button
                    fullWidth
                    className="cg-secondary-btn"
                    style={{ marginTop: '16px' }}
                    onClick={() => toggleMode('login')}
                    disabled={isLoading}
                >
                    Back to Login
                </Button>
            </Paper>
        </Grid>
    );
};

export default RegisterNewUser;
